import EditorAddon from '../EditorAddon'

function NotesAddon (props) {
  return <EditorAddon type="notes" {...props} />
}

export default NotesAddon
